import styled, { css } from 'styled-components';
import _Button from 'components/Button';
import { H1, H4, P } from 'components/Typography';
import { th } from 'style/theme';
import { motion } from 'framer-motion';
import { sizes } from 'style';

export const PlatformsWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
`;

export const SignupButton = styled(_Button)`
  font-family: 'Helvetica Now', Arial, sans-serif;
  margin-top: 20px;
  padding: 6px 28px;
  font-size: 16px;
  border-radius: 10px;

  @media ${sizes.tabletPortrait} {
    padding: 9px 36px;
    font-size: 20px;
    margin-top: 32px;
  }
`;

export const NomadInsuranceSignup = styled(SignupButton)`
  background-color: ${({ theme }) => theme.colors.yellow};

  :hover {
    background-color: #ffdf74;
  }

  :active {
    background-color: #ffebaa;
  }
`;

export const RemoteHealthSignup = styled(SignupButton)`
  background-color: ${({ theme }) => theme.colors.bermudaGreen};

  :hover {
    background-color: #a8e8d0;
  }

  :active {
    background-color: #caebde;
  }
`;

export const Button = styled(_Button)`
  margin-top: 42px;
  padding: 10px 0px;
  width: 242px;
  font-size: 20px;
  font-weight: bold;
  border: 1px solid ${th('colors.white')};
  color: ${th('colors.white')};
  background-color: transparent;
  border-radius: 10px;
  box-shadow: none;

  :hover {
    background-color: #fff;
    color: ${th('colors.black')};
  }
`;

export const Platform = styled(motion.div)`
  padding-top: 75px;
  padding-left: 15px;
  padding-right: 15px;
  z-index: 2;
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  @media ${sizes.mobileMedium} {
    padding-right: 20px;
    padding-left: 20px;
    padding-top: 85px;
  }

  @media ${sizes.tabletPortrait} {
    padding-top: 21vh;
  }

  @media (min-height: 1000px) and (min-width: 576px) {
    width: 50%;
  }

  @media (min-width: 1124px) {
    width: 36.5%;
  }

  @media (min-height: 1000px) and (min-width: 1124px) {
    padding-top: 24.5vh;
  }

  ${({ product }) =>
    product === 'Nomad Insurance' &&
    css`
      @media ${sizes.tabletPortrait} {
        align-items: flex-end;
        padding-right: 34px;
        padding-left: 40px;
      }
    `}

  ${({ product }) =>
    product === 'Remote Health' &&
    css`
      align-items: flex-start;

      @media ${sizes.tabletPortrait} {
        padding-left: 43px;
        padding-right: 40px;
      }
    `}
`;

export const Title = styled(H1)`
  font-family: 'Helvetica Now', Arial, sans-serif;
  color: ${th('colors.white')};
  letter-spacing: 0;
  font-size: 19px;
  line-height: 28px;

  @media ${sizes.mobileMedium} {
    font-size: 22px;
  }

  @media (min-width: 1100px) {
    font-size: 4vw;
    line-height: 4.55vw;
  }

  @media (min-height: 830px) and (min-width: 1500px) {
    font-size: 4.7vw;
    line-height: 5.35vw;
  }

  @media (min-height: 830px) and (min-width: 1660px) {
    font-size: 78px;
    line-height: 89px;
  }
`;

export const Description = styled(P)`
  font-family: 'Helvetica Now', Arial, sans-serif;
  color: ${th('colors.white')};
  margin-top: 8px;
  font-size: 14px;
  line-height: 24px;
  max-width: 520px;

  @media ${sizes.mobileMedium} {
    font-size: 16px;
  }
  @media ${sizes.tabletPortrait} {
    margin-top: 15px;
  }

  @media (min-width: 1200px) {
    font-size: 1.35vw;
    line-height: 2vw;
  }

  @media (min-width: 1500px) {
    font-size: 1.55vw;
    line-height: 2.15vw;
  }

  @media (min-width: 1660px) {
    font-size: 26px;
    line-height: 36px;
  }
`;

export const PlatformsBackground = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;

  > div {
    width: 50%;
    height: 100%;

    :first-child {
      background: linear-gradient(
        180deg,
        rgba(60, 141, 142, 1) 0%,
        rgba(83, 177, 178, 0.7) 53%,
        rgba(92, 198, 199, 0.45) 100%
      );

      @media ${sizes.tabletPortrait} {
        background: linear-gradient(
          90deg,
          rgba(60, 141, 142, 1) 0%,
          rgba(83, 177, 178, 0.9) 46%,
          rgba(92, 198, 199, 0.35) 100%
        );
      }
    }

    :last-child {
      background: linear-gradient(
        180deg,
        rgba(65, 65, 150, 1) 0%,
        rgba(79, 79, 177, 0.7) 46%,
        rgba(86, 86, 194, 0.35) 100%
      );

      @media ${sizes.tabletPortrait} {
        background: linear-gradient(
          270deg,
          rgba(65, 65, 150, 1) 0%,
          rgba(79, 79, 177, 0.9) 53%,
          rgba(86, 86, 194, 0.35) 100%
        );
      }
    }
  }
`;

export const BirdContainer = styled(motion.div)`
  z-index: 2;
  height: 100%;
  background-color: transparent;
  position: absolute;
  width: 40%;
  left: 35%;

  @media ${sizes.tabletPortrait} {
    width: 30%;
    left: 35%;
  }

  @media (min-height: 900px) and (min-width: 576px) {
    position: absolute;
    left: 35%;
  }

  @media (min-width: 1124px) {
    left: 0;
    width: 27%;
    position: relative;
  }
`;

export const BirdImg = styled(motion.img)`
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: auto;

  @media ${sizes.tabletPortrait} {
    bottom: 0;
  }
`;

export const ProductText = styled(H4)`
  font-size: 12px;
  cursor: pointer;

  @media (min-width: 576px) {
    font-size: 20px;
  }
`;

export const ProductArrow = styled.div`
  display: flex;
  width: calc(100% + 16px);
  align-items: center;
  margin-top: -4px;
  transition: 0.3s;

  > div {
    background-color: #fff;
    height: 3px;
    border-radius: 2px;
    width: 100%;
  }

  > img {
    margin-left: -6px;
  }
`;

export const ProductButton = styled.div`
  margin-top: 40px;
  cursor: pointer;

  :hover {
    > ${ProductArrow} {
      width: calc(100% + 28px);
    }
  }
`;
